import { render, staticRenderFns } from "./cadlocalizacoes.vue?vue&type=template&id=0a675db4&"
import script from "./cadlocalizacoes.vue?vue&type=script&lang=js&"
export * from "./cadlocalizacoes.vue?vue&type=script&lang=js&"
import style0 from "./cadlocalizacoes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports